
//This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
function distance(lat1, lon1, lat2, lon2) {

  lat1 = Number(lat1)
  lat2 = Number(lat2)
  lon1 = Number(lon1)
  lon2 = Number(lon2)

  // console.log(`
  //   lat1: ${lat1}
  //   lat2: ${lat2}
  //   lon1: ${lon1}
  //   lon2: ${lon2}
  //   `)

  let r = 6371 // km
  let dLat = toRad(lat2-lat1)
  let dLon = toRad(lon2-lon1)
  lat1 = toRad(lat1)
  lat2 = toRad(lat2)

  // console.log(`
  //   dLat: ${dLat}
  //   dLon: ${dLon}
  //   `)

  let a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2)
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
  let d = r * c

  // console.log(`
  //   a: ${a}
  //   c: ${c}
  //   d: ${d}
  //   `)
  //console.log(`d: ${d}`)
  return d
}

// Converts numeric degrees to radians
function toRad(value) {
  return value * Math.PI / 180;
}

export const googleEarth = (filter, jobs, props, library, logs) => {

  const fs = window.require('fs')

  // var dir = './derpy';
  //
  // if (!fs.existsSync(dir)){
  //     fs.mkdirSync(dir);
  // }

  async function awaitSiteLocation(coords) {
    //console.log(`coords ${JSON.stringify(coords)}`)
    let coordArr
    let txt = ''

    for (let i=0; i < coords.length; i++) {

      let result = await Promise.resolve(i)
      coordArr = coords[i].split(',')
      txt += `${coordArr[1]},${coordArr[0]},0 `

    }

    // close the polygon
    coordArr = coords[0].split(',')
    txt += `${coordArr[1]},${coordArr[0]},0 `

    return txt

  }

  async function awaitJobs(jobs) {
    //console.log(`jobs: ${JSON.stringify(jobs)}`)
    let polygon
    let txt = ''

    for (let i=0; i < jobs.length; i++) {

      let result = await Promise.resolve(i)

      let radius = distance(jobs[i].latitude, jobs[i].longitude, filter.latitude, filter.longitude) // 8 km

      if (jobs[i].jobnumber !== '' && jobs[i].jobnumber !== null &&
        (filter.jobNumber !== '' && filter.jobNumber !== null && radius < 8) ||
        (filter.jobNumber === '' || filter.jobNumber === null)
      ) {

        polygon = ''

        if (jobs[i].sitelocation !== '' && jobs[i].sitelocation !== null) {

          polygon = await awaitSiteLocation(jobs[i].sitelocation.split(" "))
          .then(res =>
            `<Placemark>

              <styleUrl>#SiteLocation</styleUrl>
              <description>
                JN: ${jobs[i].jobnumber}<br />
                PN: ${jobs[i].proposal !== '' && jobs[i].proposal !== null ? `${jobs[i].proposal}-${jobs[i].proposalyear}` : ''}
              </description>

              <Polygon>
                  <tessellate>1</tessellate>
                  <outerBoundaryIs>
                      <LinearRing>
                          <coordinates>
                            ${res}
                          </coordinates>
                      </LinearRing>
                  </outerBoundaryIs>
              </Polygon>

            </Placemark>
            `
          )
          .catch(err => console.log(`err: ${err}`))

        }

        txt += `
        <Folder>

          <name>${jobs[i].jobnumber}</name>

          <Placemark>

            <description>
              JN: ${jobs[i].jobnumber}<br />
              PN: ${jobs[i].proposal !== '' && jobs[i].proposal !== null ? `${jobs[i].proposal}-${jobs[i].proposalyear}` : ''}<br />
              Client: <br />
              Description: ${jobs[i].projectdescription}<br />
              Address: <br />
              Job Date: ${jobs[i].jobdate}<br />
            </description>

            <styleUrl>${jobs[i].proposal !== '' && jobs[i].proposal !== null ? '#IconBoth' : '#IconJN'}</styleUrl>

            <Point>
              <coordinates>${jobs[i].longitude},${jobs[i].latitude}</coordinates>
            </Point>

          </Placemark>

          ${polygon}

        </Folder>
        `
      }

    }

    return txt

  }

  async function awaitProps(props) {
    //console.log(`jobs: ${JSON.stringify(jobs)}`)
    let polygon
    let txt = ''

    for (let i=0; i < props.length; i++) {

      let result = await Promise.resolve(i)

      let radius = distance(props[i].latitude, props[i].longitude, filter.latitude, filter.longitude) // 8 km

      if (
        ((filter.jobNumber === '' || filter.jobNumber === null) && radius < 8)        
      ) {

        polygon = ''

        if (props[i].sitelocation !== '' && props[i].sitelocation !== null) {

          polygon = await awaitSiteLocation(props[i].sitelocation.split(" "))
          .then(res =>
            `<Placemark>

              <styleUrl>#SiteLocation</styleUrl>
              <description>
                JN: ${props[i].jobnumber}<br />
                PN: ${props[i].proposal !== '' && props[i].proposal !== null ? `${props[i].proposal}-${props[i].proposalyear}` : ''}
              </description>

              <Polygon>
                  <tessellate>1</tessellate>
                  <outerBoundaryIs>
                      <LinearRing>
                          <coordinates>
                            ${res}
                          </coordinates>
                      </LinearRing>
                  </outerBoundaryIs>
              </Polygon>

            </Placemark>
            `
          )
          .catch(err => console.log(`err: ${err}`))

        }

        txt += `
        <Folder>

          <name>${props[i].proposal}</name>

          <Placemark>

            <description>
              JN: ${props[i].jobnumber}<br />
              PN: ${props[i].proposal !== '' && props[i].proposal !== null ? `${props[i].proposal}-${props[i].proposalyear}` : ''}<br />
              Client: <br />
              Description: ${props[i].projectdescription}<br />
              Address: <br />
              Job Date: ${props[i].jobdate}<br />
            </description>

            <styleUrl>#IconPN</styleUrl>

            <Point>
              <coordinates>${props[i].longitude},${props[i].latitude}</coordinates>
            </Point>

          </Placemark>

          ${polygon}

        </Folder>
        `
      }

    }

    return txt

  }

  async function awaitLibrary(library) {
    //console.log(`jobs: ${JSON.stringify(jobs)}`)
    let polygon
    let txt = ''

    for (let i=0; i < library.length; i++) {

      let result = await Promise.resolve(i)

      let radius = distance(library[i].latitude, library[i].longitude, filter.latitude, filter.longitude) // 8 km

      if (
        (filter.jobNumber !== '' && filter.jobNumber !== null && radius < 8) ||
        (filter.jobNumber === '' || filter.jobNumber === null)
      ) {

        polygon = ''

        if (library[i].siteLocation !== '' && library[i].siteLocation !== null) {

          polygon = await awaitSiteLocation(library[i].siteLocation.split(" "))
          .then(res =>
            `<Placemark>

              <styleUrl>#SiteLocation</styleUrl>
              <description>
                ID: ${library[i].id}<br />
                Company: ${library[i].company}
              </description>

              <Polygon>
                  <tessellate>1</tessellate>
                  <outerBoundaryIs>
                      <LinearRing>
                          <coordinates>
                            ${res}
                          </coordinates>
                      </LinearRing>
                  </outerBoundaryIs>
              </Polygon>

            </Placemark>
            `
          )
          .catch(err => console.log(`err: ${err}`))

        }

        txt += `
        <Folder>

          <name>Library${library[i].id}</name>

          <Placemark>

            <description>
              ID: ${library[i].id}<br />
              Company: ${library[i].company}<br />              
              Description: ${library[i].description}<br />
              Address: ${library[i].address}<br />
              Job Date: ${library[i].jobDate}<br />
            </description>

            <styleUrl>#IconOtherReports</styleUrl>

            <Point>
              <coordinates>${library[i].longitude},${library[i].latitude}</coordinates>
            </Point>

          </Placemark>

          ${polygon}

        </Folder>
        `
      }

    }

    return txt

  }

  async function awaitLogs(logs) {

    // async
    // const fileExists = (file) => {
    //   return new Promise((resolve) => {
    //     fs.access(file, fs.constants.F_OK, (err) => {
    //       err ? resolve(false) : resolve(true)
    //     });
    //   })
    // }

    let file
    let txt = ''

    for (let i=0; i < logs.length; i++) {

      let result = await Promise.resolve(i)

      let radius = distance(logs[i].latitude, logs[i].longitude, filter.latitude, filter.longitude) // 8 km

      if (
        (filter.jobNumber !== '' && filter.jobNumber !== null && radius < 8) ||
        (filter.jobNumber === '' || filter.jobNumber === null)
      ) {

        if (logs[i].gw === '' || logs[i].gw === null) {

          txt += `<Placemark>
          <name>No GW to ${logs[i].depth} on ${logs[i].drillDate}</name>
             <name>${logs[i].depth}</name>
             <styleUrl>#IconNoGW</styleUrl>
             <Point>
                 <coordinates>${logs[i].longitude}, ${logs[i].latitude}</coordinates>
             </Point>
           </Placemark>`

        } else {

          txt += `<Placemark>
          <name>GW at ${logs[i].gw} on ${logs[i].drillDate}</name>
             <name>${logs[i].gw}</name>
             <styleUrl>#IconGW</styleUrl>
             <Point>
                 <coordinates>${logs[i].longitude}, ${logs[i].latitude}</coordinates>
             </Point>
           </Placemark>`

        }

        //let file = `T:\Databases\Admin\Archive\Logs\${logs[i].jobNumber} ${logs[i].location}.pdf`

        let file = logs[i].library === 1 ? `https://jobs.albus-data.net/library/library${logs[i].libraryId}.pdf` : `https://jobs.albus-data.net/logs/log${logs[i].id}.pdf`

        let str = logs[i].library === 1 ? `Library Id: ${logs[i].libraryId}` : `Job Number: ${logs[i].jobNumber}`

        // ${fileExists(file) ?
        //   `<a href='file:///T:/Databases/Admin/Archive/Logs/${logs[i].jobNumber}%20${logs[i].location}.pdf'>View Log</a>
        //   Not working? Try clicking above...<br />
        //   'Tools'-->'Options'-->'General'<br />
        //   Select 'Allow access to local files'<br />
        //   Select 'Show web results in external browser'<br />` :
        //   `<b>A PDF has not been created for viewing.</b><br />`
        // }

        txt += `<Placemark>
        <name>${logs[i].location}</name>
          <description>
            ${str}<br />
            Location: ${logs[i].location}<br />
            Depth: ${logs[i].depth}<br />
            GW: ${logs[i].gw === '' || logs[i].gw === null ? '<b>Not Encountered</b>' : logs[i].gw}<br />
            Drill Date: ${logs[i].drillDate}<br />
            Logged By: ${logs[i].loggedBy}<br />
            Driller: ${logs[i].driller}<br />
            Drill Method: ${logs[i].drillMethod}<br />
            Elevation: ${logs[i].elevation}<br />            
            <a href='${file}'>View Log</a>
            Not working? Try clicking above...<br />
            'Tools'-->'Options'-->'General'<br />
            Select 'Allow access to local files'<br />
            Select 'Show web results in external browser'<br />
          </description>
          ${logs[i].percWell === 1 ? `<styleUrl>#IconPercolation</styleUrl>` : logs[i].library === 1 ? `<styleUrl>#IconLibraryBorings</styleUrl>` : `<styleUrl>#IconBorings</styleUrl>`}
          <Point>
          <coordinates>${logs[i].longitude}, ${logs[i].latitude}</coordinates>
          </Point>
        </Placemark>`

      }

    }

    txt =
    `<Folder>
      <name>Exploration</name>
      ${txt}
    </Folder>
    `
    //console.log(`logs: ${logs.length}`)
    return txt

  }

  awaitJobs(jobs)
  .then(async res => {

    let propResult = await awaitProps(props).catch(err => console.log(`awaitProps err: ${err}`))

    let libraryResult = await awaitLibrary(library).catch(err => console.log(`awaitLibrary err: ${err}`))

    let logResult = await awaitLogs(logs).catch(err => console.log(`awaitLogs err: ${err}`))

    let file = `<?xml version="1.0" encoding="UTF-8"?>
    <kml xmlns="http://www.opengis.net/kml/2.2" xmlns:gx="http://www.google.com/kml/ext/2.2" xmlns:kml="http://www.opengis.net/kml/2.2" xmlns:atom="http://www.w3.org/2005/Atom">
      <Document>
      <name>Albus Data</name>
        <LookAt>
          <longitude>${filter.longitude}</longitude>
          <latitude>${filter.latitude}</latitude>
          <altitude>0</altitude>
          <heading>0</heading>
          <tilt>0</tilt>
          <range>1000.00000</range>
          <gx:altitudeMode>relativeToSeaFloor</gx:altitudeMode>
        </LookAt>
        <Style id="Selected">
             <IconStyle>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/paddle/ylw-stars.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconJN">
             <IconStyle>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/paddle/blu-circle.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconPN">
             <IconStyle>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/paddle/red-circle.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconBoth">
             <IconStyle>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/paddle/grn-circle.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconOtherReports">
             <IconStyle>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/paddle/pink-circle.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconBorings">
             <IconStyle>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/shapes/placemark_circle.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconLibraryBorings">
             <IconStyle>
              <color>ff0000ff</color>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/shapes/placemark_circle.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconPercolation">
             <IconStyle>
             <color>ffffff55</color>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/shapes/placemark_circle.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconNoGW">
             <LabelStyle>
               <color>ff0000cc</color>
               <scale>0.75</scale>
             </LabelStyle>
             <IconStyle>
             <scale>0</scale>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/shapes/water.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="IconGW">
             <LabelStyle>
               <color>ff00ff00</color>
               <scale>0.75</scale>
             </LabelStyle>
             <IconStyle>
             <scale>0</scale>
               <Icon>
                   <href>http://maps.google.com/mapfiles/kml/shapes/water.png</href>
               </Icon>
             </IconStyle>
        </Style>
        <Style id="SiteLocation">
            <LineStyle>
                <color>ff00ff00</color>
                <width>2</width>
            </LineStyle>
            <PolyStyle>
                <color>4000ff00</color>
            </PolyStyle>
        </Style>
        <Style id="SiteLocationOther">
            <LineStyle>
                <color>ffff55ff</color>
                <width>2</width>
            </LineStyle>
            <PolyStyle>
                <color>40ff55ff</color>
            </PolyStyle>
        </Style>
        <Folder>
          <name>Jobs</name>
          ${res}
        </Folder>
        <Folder>
          <name>Props</name>
          ${propResult}
        </Folder>
        <Folder>
          <name>Library</name>
          ${libraryResult}
        </Folder>
        ${logResult}
      </Document>
    </kml>
    `
    file = file.replaceAll('&', 'and')
    fs.writeFileSync('Albus Data.kml', file, 'utf-8')

  })
  .catch(e => {
    alert('Failed to save the file !');
    console.log(`e: ${JSON.stringify(e)}`)
  })

}
